/**
 * Searches for messaging channels where the user is a member and the member's name matches the query.
 *
 * @param {Object} client - The chat client instance.
 * @param {string} query - The search string to match against member names.
 * @param {string} userId - The ID of the user performing the search.
 * @param {Object} options - Pagination and query options ({ limit, offset, etc }).
 * @returns {Promise<Array>} - Array of matching channel objects.
 *
 * How it works:
 * - Filters channels of type 'messaging' where the user is a member.
 * - Matches channels where a member's name matches the query (autocomplete).
 * - Restricts results to the user's first team.
 * - Sorts channels by last message and update time (descending).
 * - Supports pagination via limit and offset.
 */
export const channelSearch = async (client, query, userId, options) => {
  const channelFilter = {
    type: "messaging",
    members: { $in: [userId] },
    "member.user.name": { $autocomplete: query },
    team: { $eq: client.user.teams[0] }
  };
  return await client.queryChannels(
    channelFilter,
    [
      { last_message_at: -1 },
      { updated_at: -1 }
    ],
    {
      limit: options.limit,
      offset: options.offset,
      watch: true,
      state: true
    }
  );
};